import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import { getAllService } from "../../../../actions/Appointment/serviceAction"
import Rendertable from "./Rendertable";

const ServiceList = ({
     getAllService, List, updatelist, setUpdatelist 
}) => {
  const [data, setData]= useState();
  useEffect(() => {
    getAllService().then((res)=>{
      console.log(res);
      setData(res);
    })
  }, []);

    return (
      <div>
        <Rendertable List={data} setUpdatelist={setUpdatelist}  />
      </div>
    );
};

export default connect(null,{
     getAllService,
})(ServiceList);

